import React from 'react';
import { CircularProgress } from '@mui/material';

export default function() {
  return (
    <div className="full-width-loader-container">
      <CircularProgress />
    </div>
  );
}
